import * as React from 'react'

function OtherCard(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={56} height={36} viewBox="0 0 56 36" {...props}>
      <g data-name="Group 56612">
        <g data-name="Group 56611">
          <g data-name="Group 56565">
            <g
              data-name="Rectangle 3289"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
              transform="translate(-1745 -1822.999) translate(1745 1822.922) translate(0 .077)"
            >
              <rect width={56} height={36} rx={2} stroke="none" />
              <rect x={0.5} y={0.5} width={55} height={35} rx={1.5} />
            </g>
          </g>
          <path
            data-name="Path 68818"
            d="M7.591 7.504l3.733.024a.941.941 0 01.871.987l.015 3.5a.92.92 0 01-.862.978l-3.733-.023a.941.941 0 01-.871-.988l-.02-3.495a.92.92 0 01.867-.983z"
            fill="#d4dade"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
            transform="translate(-1745 -1822.999) translate(1745 1822.922)"
          />
          <g
            data-name="Rectangle 8957"
            transform="translate(-1745 -1822.999) translate(1745 1822.922) translate(40.979 24.3)"
            fill="#d4dade"
            stroke="#263238"
            strokeWidth={1}
          >
            <rect width={9} height={5.304} rx={2.652} stroke="none" />
            <rect x={0.5} y={0.5} width={8} height={4.304} rx={2.152} fill="none" />
          </g>
          <g
            data-name="Rectangle 8958"
            transform="translate(-1745 -1822.999) translate(1745 1822.922) translate(41 17.915)"
            fill="#d4dade"
            stroke="#263238"
            strokeWidth={1}
          >
            <rect width={9} height={3} rx={1.5} stroke="none" />
            <rect x={0.5} y={0.5} width={8} height={2} rx={1} fill="none" />
          </g>
          <g
            data-name="Rectangle 8959"
            transform="translate(-1745 -1822.999) translate(1745 1822.922) translate(29 17.915)"
            fill="#d4dade"
            stroke="#263238"
            strokeWidth={1}
          >
            <rect width={9} height={3} rx={1.5} stroke="none" />
            <rect x={0.5} y={0.5} width={8} height={2} rx={1} fill="none" />
          </g>
          <g
            data-name="Rectangle 8960"
            transform="translate(-1745 -1822.999) translate(1745 1822.922) translate(18 17.915)"
            fill="#d4dade"
            stroke="#263238"
            strokeWidth={1}
          >
            <rect width={9} height={3} rx={1.5} stroke="none" />
            <rect x={0.5} y={0.5} width={8} height={2} rx={1} fill="none" />
          </g>
          <g
            data-name="Rectangle 8961"
            transform="translate(-1745 -1822.999) translate(1745 1822.922) translate(6 17.915)"
            fill="#d4dade"
            stroke="#263238"
            strokeWidth={1}
          >
            <rect width={9} height={3} rx={1.5} stroke="none" />
            <rect x={0.5} y={0.5} width={8} height={2} rx={1} fill="none" />
          </g>
          <path
            data-name="Path 68823"
            d="M17.169 8.335a4.52 4.52 0 01.009 3.855"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1.2}
            transform="translate(-1745 -1822.999) translate(1745 1822.922)"
          />
          <path
            data-name="Path 68824"
            d="M15.198 9.438a1.964 1.964 0 010 1.675"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1.2}
            transform="translate(-1745 -1822.999) translate(1745 1822.922)"
          />
        </g>
      </g>
    </svg>
  )
}

export default OtherCard
